// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const agingIntoMedicareEntryPointTypeEnum = {
  AGING_INTO_MEDICARE: "AGING_INTO_MEDICARE",
} as const;

export type AgingIntoMedicareEntryPointTypeEnumKey =
  (typeof agingIntoMedicareEntryPointTypeEnum)[keyof typeof agingIntoMedicareEntryPointTypeEnum];

export const agingIntoMedicareTypeEnum = {
  VANCE_AGING_INTO_MEDICARE: "VANCE_AGING_INTO_MEDICARE",
} as const;

export type AgingIntoMedicareTypeEnumKey =
  (typeof agingIntoMedicareTypeEnum)[keyof typeof agingIntoMedicareTypeEnum];

export type AgingIntoMedicare = {
  /**
   * @type string
   */
  entryPointType: AgingIntoMedicareEntryPointTypeEnumKey;
  /**
   * @type string
   */
  memberId: string;
  /**
   * @type string
   */
  state: string;
  /**
   * @description The date the member turns 65.
   * @type string, date
   */
  turning65Date: string;
  /**
   * @type string
   */
  type: AgingIntoMedicareTypeEnumKey;
  /**
   * @type string
   */
  workspaceId: string;
};
